<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https" /> {{ caption }}
        <div class="card-header-actions">
          <CButton color="success" size="sm" @click="exportData()">Exportar a Excel</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable :tableFilter="tableFilter" :hover="hover" :striped="striped" :border="border" :small="small"
        :fixed="fixed" :items="items" :fields="fields" :items-per-page="50" :dark="dark" pagination>
        <template #event_points-header>
          Eventos<br>
          <span class="text-muted" style="font-size:11px;">
            Real / Aprob.
          </span>
        </template>
        <template #card_points-header>
          Tarjeta<br>
          <span class="text-muted" style="font-size:11px;">
            Real / Aprob.
          </span>
        </template>
        <template #gift_points-header>
          Regalo<br>
          <span class="text-muted" style="font-size:11px;">
            Real / Aprob.
          </span>
        </template>
        <template #wallet_points-header>
          Monedero<br>
          <span class="text-muted" style="font-size:11px;">
            Real / Aprob.
          </span>
        </template>

        <template #code="{ item }">
          <td class="text-center w50 p-0" style="font-size: 12px;">{{ item.code }}</td>
        </template>
        <template #name="{ item }">
          <td style="font-size: 12px;">{{ item.name }}</td>
        </template>
        <template #wallet="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ (item.wallet) ? item.wallet : '-' }}</td>
        </template>
        <template #stock="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ (item.stock) ? item.stock : '-' }}</td>
        </template>
        <template #event_points="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.event_points_total }}<span class="text-muted" style="font-size: 12px;"> / {{ item.event_points_active }}</span></td>
        </template>
        <template #card_points="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.card_points_total }}<span class="text-muted" style="font-size: 12px;"> / {{ item.card_points_active }}</span></td>
        </template>
        <template #gift_points="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.gift_points_total }}<span class="text-muted" style="font-size: 12px;"> / {{ item.gift_points_active }}</span></td>
        </template>
        <template #wallet_points="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.wallet_points_total }}<span class="text-muted" style="font-size: 12px;"> / {{ item.wallet_points_active }}</span></td>
        </template>
        <template #actions="{ item }">
          <td class="table_actions b2">
            <CButton color="info" size="sm" @click="updatePointsModal(item)">Modificar</CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <PointsModal ref="pointsModal" @refreshManagers="refreshManagers" @refreshSuppliers="refreshSuppliers" @refreshGerentes="refreshGerentes"></PointsModal>
  </CCard>
</template>

<script>
import ws_suppliers from '../../services/suppliers';
import ws_managers from '../../services/managers';
import ws_executives from '../../services/executives';
import store from '../../store'
import router from '../../router/index'
import PointsModal from './PointsModal.vue'

export default {
  name: 'PointsTable',
  components: { PointsModal },
  props: {
    items: Array,
    permissions: Object,
    entityType: {
      type: String,
      required: true // 'suppliers' | 'managers' | 'gerentes'
    },
    fields: {
      type: Array,
      default() {
        return [
          { key: 'code', label: 'Ruta', _style: 'font-size: 12px;' },
          { key: 'name', label: 'Nombre', _style: 'font-size: 12px;' },
          { key: 'wallet', label: 'Monedero', _style: 'font-size: 12px;' },
          { key: 'stock', label: 'Stock', _style: 'font-size: 12px;' },
          { key: 'event_points', label: 'Eventos', _style: 'font-size: 12px; width: 110px;' },
          { key: 'card_points', label: 'Tarjeta', _style: 'font-size: 12px; width: 110px;' },
          { key: 'gift_points', label: 'Regalo', _style: 'font-size: 12px; width: 110px;' },
          { key: 'wallet_points', label: 'Monedero', _style: 'font-size: 12px; width: 110px;' },
          { key: 'actions', label: '' }
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    async exportData() {
      this.loading();
      let response;
      if(this.entityType === 'suppliers') {
        response = await ws_suppliers.getExcelRedeemablePoints();
      } else if(this.entityType === 'managers') {
        response = await ws_managers.getExcelRedeemablePoints();
      } else if(this.entityType === 'gerentes') {
        response = await ws_executives.getExcelRedeemablePoints();
      }
      if (response.type == "success") {
        window.location = response.data;
      }
      this.loaded();
    },
    updatePointsModal(item) {
      this.$refs.pointsModal.updatePointsModal(item, this.entityType);
    },
    async refreshSuppliers() {
      this.$emit("refreshSuppliers");
    },
    async refreshManagers() {
      this.$emit("refreshManagers");
    },
    async refreshGerentes() {
      this.$emit("refreshGerentes");
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>

<style>
table td {
  padding: 5px 0px 0px 10px !important;
}
</style>
